import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";
import { control } from "./modules/controls";
import { gtm } from "../../components/gtm";
import { utils } from "../../helpers/utils";
import { services } from "../../helpers/service";
import { dialog } from "../../components/dialog";
import { captcha } from "../../components/captcha";
import { animation } from "../../helpers/animation";
import { importLib } from "../../helpers/async-libs";

/*------------------------------------*\
  #FORMS VALIDATION

  Class gestion des formulaires

\*------------------------------------*/
class FormValidation {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));

  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT KEYUP
    document.addEventListener('submit', this.submitHandler);

    if(debug.DEBUG) console.log('async/form/form-validation.js');
  }

  /**
   * CLOSE ON ESC SUBMIT
   * 
   * Fermeture des sub-nav au clic sur la touche echap
   * @param {event} event 
   */
  submitHandler = (event) => {
    if (event.target.matches('[data-js-module="form-validation"]')) {

      event.stopPropagation();
      event.preventDefault();
      this.controlsValidation(event.target);
      return false;
    }
  }

  /**
   * CONTROLS VALIDATION
   * 
   * Vérification de tous les champs
   * obligatoire ou avec des formats défini
   * 
   * @param {HTMLElement} form 
   * @returns 
   */
  controlsValidation = (form) => {
    const elements = form.querySelectorAll('[data-js-form-controls],[required]');
    if (!elements.length) return;
  
    importLib('form/modules/controls.js').then((control) => {
      let error = false;
    
      elements.forEach(element => {
        if (element.getAttribute('tabindex') === '-1') return;
        
        const { error: hasError, message } = control.check(element);
        const field = element.closest('.c-form__field');
        if (!field) return;
    
        const errorLabel = field.querySelector('.c-form__error');
        field.classList.toggle('c-form__field--error', hasError);
    
        if (errorLabel) {
          errorLabel.innerHTML = hasError ? message : '';
          errorLabel.setAttribute('aria-hidden', !hasError);
          element.setAttribute('aria-describedby', errorLabel.id);
        }
    
        if (hasError) {
          error = true;
          element.setAttribute('aria-invalid', true);
        } else {
          element.removeAttribute('aria-invalid');
          element.removeAttribute('aria-describedby');
        }
      });
    
      if (error) {
        this.goToFirstError(form);
      } else {
        if (form.matches('[data-js-crossknowledge-form]')) {
          utils.dispatchEvent('FORM_CK_VALIDATION', { form, error });
        } else {
          this.submitAjaxForm(form);
        }
      }
    });
  };
  submitAjaxForm = (form) => {
    const action = form.getAttribute('action');
    const params = new FormData(form);
    services.ajax({
      url: action,
      data: params,
      type: 'post',
      dataType: "json",
      processData: false,
      contentType: false
    }).then((response) => {
      this.formPrestationTracker(form);
      const address = response.datas.url;
      if (typeof address === 'string') {
          location.href = address;
      }
    }).catch((error) => {
      this.showAjaxFormError(form, error.responseJSON.datas.error);
    });
  }

  showAjaxFormError = (form, error) => {
    const errorElement = form.querySelector('.c-form__errors');
    if (errorElement) {
      error.forEach((el) => {
        const errorItem = document.createElement('li');
        errorItem.textContent = el.message;
        errorElement.appendChild(errorItem);
      });
      captcha.reset();
      animation.scrollTo(form.offsetTop - 100, 1000);
      errorElement.setAttribute('aria-hidden', false);
      dialog.error('Erreur lors de la soumission du formulaire');
    }
  }
  /**
   * Tracks form prestation events using Google Tag Manager (GTM).
   *
   * This function selects all checked elements with the class 'js-form-prestation'
   * within the provided form. For each selected element, it retrieves the prestation
   * name from the 'data-js-prestation-name' attribute and sends a tracking event
   * to GTM with the event name 'EnvoiFormulairePrestations' and the prestation name.
   *
   * @param {HTMLFormElement} form - The form element containing prestation checkboxes.
   */
  formPrestationTracker = (form) => {
    const prestationElements = form.querySelectorAll('.js-form-prestation:checked');
    if (!prestationElements.length) return;
    prestationElements.forEach(element => {
      const name = element.getAttribute('data-js-prestation-name');
      gtm.track({
        event: 'EnvoiFormulairePrestations',
        prestation: name
      });
    });
  }

  /**
   * Focuses on the first input element with an error in the given form.
   *
   * @param {HTMLFormElement} form - The form element to search for errors.
   */
  goToFirstError = (form) => {
    const firstElementErrorInput = form.querySelector('.c-form__field.c-form__field--error input');
    if (firstElementErrorInput) {
      firstElementErrorInput.focus();
    }
  }
}
export default new FormValidation('[data-js-module="form-validation"]'); 